var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox"},on:{"change":_vm.handleChange}}),_c('span',{staticClass:"slider round"})])
}
var staticRenderFns = []

export { render, staticRenderFns }